// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"979adc70","884":"31c85faa"}[chunkId] + ".chunk.js";
};